import { graphql } from "@/gql";

export const blockBookingCustomerMutation = graphql(`
  mutation BlockBookingCustomer($input: BlockBookingCustomerInput!) {
    blockBookingCustomer(input: $input) {
      id
      email
      phone
      user_id
      created_at
    }
  }
`);

export const deleteBlocklistMutation = graphql(`
  mutation DeleteBlocklist($id: ID!) {
    deleteBlocklist(id: $id) {
      id
    }
  }
`);

export const unblockBookingCustomerMutation = graphql(`
  mutation UnblockBookingCustomer($booking_id: ID!) {
    unblockBookingCustomer(booking_id: $booking_id)
  }
`);
